import 'bootstrap/dist/css/bootstrap.css';
import '../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'rc-tree/assets/index.css';
import '../../styles/portal/main.scss';
import '@checkmarx/cx-ui/dist/index.css';


// WEBPACK FOOTER //
// ./src/services/ui/cssReferences.js